<template>
  <div class="l-main-content l-main-content--select-condition">
    <!--
            <div class="p-message-select-condition-type">
                <div class="c-tab">
                    <ul class="c-tab-list">
                        <li class="c-tab-list__item is-active" data-type="standard">基本的な条件から選ぶ</li>
                        <li class="c-tab-list__item" data-type="advanced">より高度な条件を設定する</li>
                        <li class="c-tab-list__item" data-type="segment">属性データの条件から選ぶ</li>
                    </ul>
                </div>
            </div>
            -->
    <div class="p-message-edit p-message-edit--standard is-active">
      <div class="p-message-edit-list">
        <!-- AND / OR -->
        <div class="p-message-edit-list__item">
          <div class="c-select-card">
            <ul class="c-select-card-list">
              <li class="c-select-card-list__item">
                <label class="c-select-card__label">
                  <input
                    v-model="conditionJoinType"
                    type="radio"
                    name="condition_type"
                    value="AND"
                  />
                  <div class="c-select-card__item">
                    <div class="c-icon u-wh80">
                      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <use xlink:href="/assets/img/sprite.svg#condition-and" />
                      </svg>
                    </div>
                    <div class="c-select-card-content">
                      <div class="c-select-card-content__title">AND条件</div>
                      <div class="c-select-card-content__text">指定したページ条件の全てを満たす</div>
                    </div>
                  </div>
                </label>
              </li>
              <li class="c-select-card-list__item">
                <label class="c-select-card__label">
                  <input
                    v-model="conditionJoinType"
                    type="radio"
                    name="condition_type"
                    value="OR"
                  />
                  <div class="c-select-card__item">
                    <div class="c-icon u-wh80">
                      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <use xlink:href="/assets/img/sprite.svg#condition-or" />
                      </svg>
                    </div>
                    <div class="c-select-card-content">
                      <div class="c-select-card-content__title">OR条件</div>
                      <div class="c-select-card-content__text">指定したページ条件のどれかを満たす</div>
                    </div>
                  </div>
                </label>
              </li>
            </ul>
            <div class="c-error c-error--balloon">
              <div class="c-error__text"></div>
            </div>
          </div>
        </div>

        <template v-for="conditionName,conditionKey in conditionInfo.conditionKeyTypes" :key="conditionKey">
          <div class="p-message-edit-list__item ">
            <div class="c-radio">
              <label class="c-radio__label">
                <input
                  v-model="conditionDetailKey"
                  type="radio"
                  name="advanced_condition_type"
                  :value="conditionKey"
                />
                <div class="c-radio__item">
                  <div class="c-radio__box"></div>
                  <div class="c-radio__box-label">{{ conditionName }}</div>
                </div>
                <div class="c-radio__text">
                  {{ conditionInfo.conditionKeyExplanations[conditionKey] }}
                </div>
              </label>
              <div class="c-error c-error--indent">
                <div class="c-error__text"></div>
              </div>
            </div>
          </div>
          <div class="p-message-edit-list__item p-message-edit-list__item--indent p-message-edit-list__item--set-custom">
            <div class="p-message-edit-condition-group">
              <div class="p-message-edit-condition-group__title">{{ conditionName }}</div>
              <template v-for="(conditionDetail, loopIndex1) in conditionDetailList[conditionKey]" :key="loopIndex1">
                <div class="p-message-edit-condition-group__item">
                  <select-text
                    v-if="conditionInfo.conditionKeyOptions[conditionKey]"
                    :place-holder="conditionName"
                    :classes="['u-w456']"
                    :value="conditionDetail.value"
                    :elements="conditionInfo.conditionKeyOptions[conditionKey]"
                    @select="conditionDetail.value = $event"
                  />

                  <div v-else class="c-input u-w456">
                    <input
                      v-model="conditionDetail.value"
                      class="c-input__item"
                      type="text"
                      name="custom_key_2_access_page_manual"
                      placeholder=""
                    />
                    <div class="c-error c-error--balloon">
                      <div class="c-error__text"></div>
                    </div>
                  </div>

                  <select-text
                    place-holder="操作"
                    :classes="['u-w162']"
                    :value="conditionDetail.operator"
                    :elements="conditionInfo.conditionKeyOperators[conditionKey]"
                    @select="onConditionKeyOperatorSelect(conditionKey)"
                  />
                </div>
              </template>
            </div>

            <button
              class="c-btn c-btn--blue-dashed u-w100p u-h40 u-fs14"
              type="button"
              name="add_custom_key_condition"
              value="add_custom_key_condition"
              @click="onAddConditionDetailClick(conditionKey)"
            >
              <div class="c-icon-circle c-icon-circle--blue u-wh20">
                <div class="c-icon-circle__item c-icon-circle__item--white u-wh12">
                  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <use xlink:href="/assets/img/sprite.svg#plus" />
                  </svg>
                </div>
              </div>
              <p class="c-btn__text">さらに条件を追加する</p>
            </button>

          </div>
        </template>

        <!--
                    <div class="p-message-edit-list__item">
                        <div class="c-radio">
                            <label class="c-radio__label">
                                <input type="radio" name="delivery_condition_type" value="1">
                                <div class="c-radio__item">
                                    <div class="c-radio__box"></div>
                                    <div class="c-radio__box-label">訪問ユーザーに配信する</div>
                                </div>
                                <div class="c-radio__text">利用シーン：○○○○○○○○した時の再訪をうながす時などに利用します</div>
                            </label>
                            <div class="c-error c-error--indent">
                                <div class="c-error__text"></div>
                            </div>
                        </div>
                    </div>
                    <div class="p-message-edit-list__item p-message-edit-list__item--indent">
                        <div class="c-checkbox c-checkbox--rows">
                            <ul class="c-checkbox-list">
                                <li class="c-checkbox-list__item">
                                    <label class="c-checkbox__label">
                                        <input type="checkbox" name="visit_user_type" value="1">
                                        <div class="c-checkbox__item">
                                            <div class="c-checkbox__box"></div>
                                            <div class="c-checkbox__box-label">5日前〜3日前に表示したユーザーに配信する</div>
                                        </div>
                                    </label>
                                </li>
                                <li class="c-checkbox-list__item">
                                    <label class="c-checkbox__label">
                                        <input type="checkbox" name="visit_user_type" value="2">
                                        <div class="c-checkbox__item">
                                            <div class="c-checkbox__box"></div>
                                            <div class="c-checkbox__box-label">以前の配信で表示したユーザーに配信する</div>
                                        </div>
                                    </label>
                                </li>
                                <li class="c-checkbox-list__item">
                                    <label class="c-checkbox__label">
                                        <input type="checkbox" name="visit_user_type" value="3">
                                        <div class="c-checkbox__item">
                                            <div class="c-checkbox__box"></div>
                                            <div class="c-checkbox__box-label">以前の配信で訪問があったユーザーにのみ配信する</div>
                                        </div>
                                    </label>
                                </li>
                                <li class="c-checkbox-list__item">
                                    <label class="c-checkbox__label">
                                        <input type="checkbox" name="visit_user_type" value="4">
                                        <div class="c-checkbox__item">
                                            <div class="c-checkbox__box"></div>
                                            <div class="c-checkbox__box-label">以前の配信で訪問がなかったユーザーにのみ配信する</div>
                                        </div>
                                    </label>
                                </li>
                            </ul>
                            <div class="c-error">
                                <div class="c-error__text"></div>
                            </div>
                        </div>
                    </div>
                    <div class="p-message-edit-list__item">
                        <div class="c-radio">
                            <label class="c-radio__label">
                                <input type="radio" name="delivery_condition_type" value="1">
                                <div class="c-radio__item">
                                    <div class="c-radio__box"></div>
                                    <div class="c-radio__box-label">アクセス履歴ページをもとに配信する</div>
                                </div>
                                <div class="c-radio__text">利用シーン：○○○○○○○○した時の再訪をうながす時などに利用します</div>
                            </label>
                        </div>
                    </div>
                    <div class="p-message-edit-list__item p-message-edit-list__item--indent p-message-edit-list__item--set-custom">
                        <div class="p-message-edit-condition-group">
                            <div class="p-message-edit-condition-group__item">
                                <div class="p-message-edit-condition-group__title">アクセス上位●●ページから選択する</div>
                                <div class="c-select u-w456">
                                    <div class="c-select__selected is-empty">ページを選択してください</div>
                                    <div class="c-select-options">
                                        <div class="c-select-options__item" data-value="cms.webpush.jp">cms.webpush.jp</div>
                                        <div class="c-select-options__item" data-value="cms.webpush.jp/a">cms.webpush.jp/a</div>
                                        <div class="c-select-options__item" data-value="cms.webpush.jp/b">cms.webpush.jp/b</div>
                                        <div class="c-select-options__item" data-value="cms.webpush.jp/a">cms.webpush.jp/c</div>
                                        <div class="c-select-options__item" data-value="cms.webpush.jp/b">cms.webpush.jp/d</div>
                                        <div class="c-select-options__item" data-value="cms.webpush.jp/a">cms.webpush.jp/e</div>
                                    </div>
                                    <div class="c-error c-error--balloon">
                                        <div class="c-error__text"></div>
                                    </div>
                                    <input type="hidden" name="access_page" value="">
                                </div>
                                <div class="c-select u-w162">
                                    <div class="c-select__selected">
                                        等しい
                                    </div>
                                    <div class="c-select-options">
                                        <div class="c-select-options__item" data-value="1">等しい</div>
                                        <div class="c-select-options__item" data-value="2">等しくない</div>
                                        <div class="c-select-options__item" data-value="3">含む</div>
                                    </div>
                                    <input type="hidden" name="access_page_operator" value="">
                                    <div class="c-error c-error--balloon">
                                        <div class="c-error__text"></div>
                                    </div>
                                </div>
                            </div>
                            <div class="p-message-edit-condition-group__item p-message-edit-condition-group__item--template">
                                <div class="c-select u-w456">
                                    <div class="c-select__selected is-empty">ページを選択してください</div>
                                    <div class="c-select-options">
                                        <div class="c-select-options__item" data-value="cms.webpush.jp">cms.webpush.jp</div>
                                        <div class="c-select-options__item" data-value="cms.webpush.jp/a">cms.webpush.jp/a</div>
                                        <div class="c-select-options__item" data-value="cms.webpush.jp/b">cms.webpush.jp/b</div>
                                        <div class="c-select-options__item" data-value="cms.webpush.jp/a">cms.webpush.jp/c</div>
                                        <div class="c-select-options__item" data-value="cms.webpush.jp/b">cms.webpush.jp/d</div>
                                        <div class="c-select-options__item" data-value="cms.webpush.jp/a">cms.webpush.jp/e</div>
                                    </div>
                                    <div class="c-error c-error--balloon">
                                        <div class="c-error__text"></div>
                                    </div>
                                    <input type="hidden" name="access_page" value="">
                                </div>
                                <div class="c-select u-w162">
                                    <div class="c-select__selected">
                                        等しい
                                    </div>
                                    <div class="c-select-options">
                                        <div class="c-select-options__item" data-value="1">等しい</div>
                                        <div class="c-select-options__item" data-value="2">等しくない</div>
                                        <div class="c-select-options__item" data-value="3">含む</div>
                                    </div>
                                    <div class="c-error c-error--balloon">
                                        <div class="c-error__text"></div>
                                    </div>
                                    <input type="hidden" name="access_page_operator" value="">
                                </div>
                            </div>
                            <div class="p-message-edit-condition-group__item">
                                <div class="p-message-edit-condition-group__title">ページを入力する</div>
                                <div class="c-input u-w456">
                                    <input class="c-input__item" type="text" name="access_page_manual" value="" placeholder="cms.webpush.jp/">
                                    <div class="c-error c-error--balloon">
                                        <div class="c-error__text"></div>
                                    </div>
                                </div>
                                <div class="c-select u-w162">
                                    <div class="c-select__selected">
                                        等しい
                                    </div>
                                    <div class="c-select-options">
                                        <div class="c-select-options__item" data-value="1">等しい</div>
                                        <div class="c-select-options__item" data-value="2">等しくない</div>
                                        <div class="c-select-options__item" data-value="3">含む</div>
                                    </div>
                                    <input type="hidden" name="access_page_manual_operator" value="">
                                    <div class="c-error c-error--balloon">
                                        <div class="c-error__text"></div>
                                    </div>
                                </div>
                            </div>
                            <div class="p-message-edit-condition-group__item p-message-edit-condition-group__item--template">
                                <div class="c-input u-w456">
                                    <input class="c-input__item" type="text" name="access_page_manual" value="" placeholder="cms.webpush.jp/">
                                    <div class="c-error c-error--balloon">
                                        <div class="c-error__text"></div>
                                    </div>
                                </div>
                                <div class="c-select u-w162">
                                    <div class="c-select__selected">
                                        等しい
                                    </div>
                                    <div class="c-select-options">
                                        <div class="c-select-options__item" data-value="1">等しい</div>
                                        <div class="c-select-options__item" data-value="2">等しくない</div>
                                        <div class="c-select-options__item" data-value="3">含む</div>
                                    </div>
                                    <input type="hidden" name="access_page_manual_operator" value="">
                                    <div class="c-error c-error--balloon">
                                        <div class="c-error__text"></div>
                                    </div>
                                </div>
                            </div>
                            <div class="p-message-edit-condition-group__text">のページ訪問履歴のあるユーザーに配信する</div>
                        </div>

                        <button class="c-btn c-btn--blue-dashed u-w100p u-h40 u-fs14" type="button" name="add_custom_key_condition" value="add_custom_key_condition">
                            <div class="c-icon-circle c-icon-circle--blue u-wh20">
                                <div class="c-icon-circle__item c-icon-circle__item--white u-wh12">
                                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                        <use xlink:href="/assets/img/sprite.svg#plus">
                                        </use>
                                    </svg>
                                </div>
                            </div>
                            <p class="c-btn__text">さらに条件を追加する</p>
                        </button>

                    </div>
                    <div class="p-message-edit-list__item">
                        <div class="c-radio">
                            <label class="c-radio__label">
                                <input type="radio" name="delivery_condition_type" value="1">
                                <div class="c-radio__item">
                                    <div class="c-radio__box"></div>
                                    <div class="c-radio__box-label">デバイス</div>
                                </div>
                                <div class="c-radio__text">利用シーン：○○○○○○○○した時の再訪をうながす時などに利用します</div>
                            </label>
                            <div class="c-error c-error--indent">
                                <div class="c-error__text"></div>
                            </div>
                        </div>
                    </div>
                    <div class="p-message-edit-list__item p-message-edit-list__item--indent p-message-edit-list__item--indent--device">
                        <div class="c-checkbox">
                            <ul class="c-checkbox-list">
                                <li class="c-checkbox-list__item">
                                    <label class="c-checkbox__label">
                                        <input type="checkbox" name="device_type" value="1">
                                        <div class="c-checkbox__item">
                                            <div class="c-checkbox__box"></div>
                                            <div class="c-checkbox__box-label">PC</div>
                                        </div>
                                    </label>
                                </li>
                                <li class="c-checkbox-list__item">
                                    <label class="c-checkbox__label">
                                        <input type="checkbox" name="device_type" value="2">
                                        <div class="c-checkbox__item">
                                            <div class="c-checkbox__box"></div>
                                            <div class="c-checkbox__box-label">スマホ</div>
                                        </div>
                                    </label>
                                </li>
                                <li class="c-checkbox-list__item">
                                    <label class="c-checkbox__label">
                                        <input type="checkbox" name="device_type" value="3">
                                        <div class="c-checkbox__item">
                                            <div class="c-checkbox__box"></div>
                                            <div class="c-checkbox__box-label">タブレット</div>
                                        </div>
                                    </label>
                                </li>
                                <li class="c-checkbox-list__item">
                                    <div class="c-checkbox__text">選択した端末のユーザーに対して配信する</div>
                                </li>
                            </ul>
                            <div class="c-error c-error--device">
                                <div class="c-error__text"></div>
                            </div>
                        </div>
                    </div>
                    -->
      </div>
    </div>
    <div class="p-message-edit p-message-edit--advanced">
      <!-- カスタムキー１ -->
      <div class="p-message-edit-list">
        <div class="p-message-edit-list__item">
          <div class="c-radio">
            <label class="c-radio__label">
              <input type="radio" name="advanced_condition_type" value="1" />
              <div class="c-radio__item">
                <div class="c-radio__box"></div>
                <div class="c-radio__box-label">カスタムキー：１</div>
              </div>
              <div class="c-radio__text">利用シーン：○○○○○○○○した時の再訪をうながす時などに利用します</div>
            </label>
            <div class="c-error c-error--indent">
              <div class="c-error__text"></div>
            </div>
          </div>
        </div>
        <div class="p-message-edit-list__item p-message-edit-list__item--indent">
          <div class="c-radio">
            <ul class="c-radio-list">
              <li class="c-radio-list__item">
                <label class="c-radio__label">
                  <input type="radio" name="advanced_condition_operator" value="1" />
                  <div class="c-radio__item">
                    <div class="c-radio__box"></div>
                    <div class="c-radio__box-label">AND条件で設定</div>
                  </div>
                </label>
              </li>
              <li class="c-radio-list__item">
                <label class="c-radio__label">
                  <input type="radio" name="advanced_condition_operator" value="2" />
                  <div class="c-radio__item">
                    <div class="c-radio__box"></div>
                    <div class="c-radio__box-label">OR条件で設定</div>
                  </div>
                </label>
              </li>
            </ul>
            <div class="c-error c-error--operator">
              <div class="c-error__text"></div>
            </div>
          </div>
        </div>
        <div class="p-message-edit-list__item p-message-edit-list__item--indent p-message-edit-list__item--set-custom">
          <div class="p-message-edit-condition-group">
            <div class="p-message-edit-condition-group__title">カスタムキー１</div>
            <div class="p-message-edit-condition-group__item">
              <div class="c-input u-w456">
                <input
                  class="c-input__item"
                  type="text"
                  name="custom_key_1_access_page_manual"
                  value=""
                  placeholder="cms.webpush.jp/"
                />
                <div class="c-error c-error--balloon">
                  <div class="c-error__text"></div>
                </div>
              </div>
              <div class="c-select u-w162">
                <div class="c-select__selected">
                  等しい
                </div>
                <div class="c-select-options">
                  <div class="c-select-options__item" data-value="1">等しい</div>
                  <div class="c-select-options__item" data-value="2">等しくない</div>
                  <div class="c-select-options__item" data-value="3">含む</div>
                </div>
                <input type="hidden" name="custom_key_1_access_page_manual_operator" value="" />
                <div class="c-error c-error--balloon">
                  <div class="c-error__text"></div>
                </div>
              </div>
            </div>
            <div class="p-message-edit-condition-group__item p-message-edit-condition-group__item--template">
              <div class="c-input u-w456">
                <input
                  class="c-input__item"
                  type="text"
                  name="custom_key_1_access_page_manual"
                  value=""
                  placeholder="cms.webpush.jp/"
                />
                <div class="c-error c-error--balloon">
                  <div class="c-error__text"></div>
                </div>
              </div>
              <div class="c-select u-w162">
                <div class="c-select__selected">
                  等しい
                </div>
                <div class="c-select-options">
                  <div class="c-select-options__item" data-value="1">等しい</div>
                  <div class="c-select-options__item" data-value="2">等しくない</div>
                  <div class="c-select-options__item" data-value="3">含む</div>
                </div>
                <input type="hidden" name="custom_key_1_access_page_manual_operator" value="" />
                <div class="c-error c-error--balloon">
                  <div class="c-error__text"></div>
                </div>
              </div>
            </div>
          </div>

          <button
            class="c-btn c-btn--blue-dashed u-w100p u-h40 u-fs14"
            type="button"
            name="add_custom_key_condition"
            value="add_custom_key_condition"
          >
            <div class="c-icon-circle c-icon-circle--blue u-wh20">
              <div class="c-icon-circle__item c-icon-circle__item--white u-wh12">
                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                  <use xlink:href="/assets/img/sprite.svg#plus" />
                </svg>
              </div>
            </div>
            <p class="c-btn__text">さらに条件を追加する</p>
          </button>

        </div>
        <div class="p-message-edit-list__item ">
          <div class="c-radio">
            <label class="c-radio__label">
              <input type="radio" name="advanced_condition_type" value="2" />
              <div class="c-radio__item">
                <div class="c-radio__box"></div>
                <div class="c-radio__box-label">カスタムキー：２</div>
              </div>
              <div class="c-radio__text">
                利用シーン：○○○○○○○○した時の再訪をうながす時などに利用します。説明文章が長い場合時の表示テスト用ダミーテキストダミーテキストダミーテキストダミーテキストダミーテキストダミーテキストダミーテキストダミーテキストダミーテキスト
              </div>
            </label>
            <div class="c-error c-error--indent">
              <div class="c-error__text"></div>
            </div>
          </div>
        </div>
        <div class="p-message-edit-list__item p-message-edit-list__item--indent p-message-edit-list__item--set-custom">
          <div class="p-message-edit-condition-group">
            <div class="p-message-edit-condition-group__title">カスタムキー２</div>
            <div class="p-message-edit-condition-group__item">
              <div class="c-input u-w456">
                <input
                  class="c-input__item"
                  type="text"
                  name="custom_key_2_access_page_manual"
                  value=""
                  placeholder="cms.webpush.jp/"
                />
                <div class="c-error c-error--balloon">
                  <div class="c-error__text"></div>
                </div>
              </div>
              <div class="c-select u-w162">
                <div class="c-select__selected">
                  等しい
                </div>
                <div class="c-select-options">
                  <div class="c-select-options__item" data-value="1">等しい</div>
                  <div class="c-select-options__item" data-value="2">等しくない</div>
                  <div class="c-select-options__item" data-value="3">含む</div>
                </div>
                <input type="hidden" name="custom_key_2_access_page_manual_operator" value="" />
                <div class="c-error c-error--balloon">
                  <div class="c-error__text"></div>
                </div>
              </div>
            </div>
            <div class="p-message-edit-condition-group__item p-message-edit-condition-group__item--template">
              <div class="c-input u-w456">
                <input
                  class="c-input__item"
                  type="text"
                  name="custom_key_2_access_page_manual"
                  value=""
                  placeholder="cms.webpush.jp/"
                />
                <div class="c-error c-error--balloon">
                  <div class="c-error__text"></div>
                </div>
              </div>
              <div class="c-select u-w162">
                <div class="c-select__selected">
                  等しい
                </div>
                <div class="c-select-options">
                  <div class="c-select-options__item" data-value="1">等しい</div>
                  <div class="c-select-options__item" data-value="2">等しくない</div>
                  <div class="c-select-options__item" data-value="3">含む</div>
                </div>
                <input type="hidden" name="custom_key_2_access_page_manual_operator" value="" />
                <div class="c-error c-error--balloon">
                  <div class="c-error__text"></div>
                </div>
              </div>
            </div>
          </div>

          <button
            class="c-btn c-btn--blue-dashed u-w100p u-h40 u-fs14"
            type="button"
            name="add_custom_key_condition"
            value="add_custom_key_condition"
          >
            <div class="c-icon-circle c-icon-circle--blue u-wh20">
              <div class="c-icon-circle__item c-icon-circle__item--white u-wh12">
                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                  <use xlink:href="/assets/img/sprite.svg#plus" />
                </svg>
              </div>
            </div>
            <p class="c-btn__text">さらに条件を追加する</p>
          </button>

        </div>
        <div class="p-message-edit-list__item">
          <div class="c-radio">
            <label class="c-radio__label">
              <input type="radio" name="advanced_condition_type" value="3" />
              <div class="c-radio__item">
                <div class="c-radio__box"></div>
                <div class="c-radio__box-label">UUID</div>
              </div>
              <div class="c-radio__text">利用シーン：○○○○○○○○した時の再訪をうながす時などに利用します</div>
            </label>
            <div class="c-error c-error--indent">
              <div class="c-error__text"></div>
            </div>
          </div>
        </div>
        <div class="p-message-edit-list__item p-message-edit-list__item--indent p-message-edit-list__item--set-custom">
          <div class="p-message-edit-condition-group">
            <div class="p-message-edit-condition-group__title">UUID</div>
            <div class="p-message-edit-condition-group__item">
              <div class="c-input u-w456">
                <input
                  class="c-input__item"
                  type="text"
                  name="uuid_access_page_manual"
                  value=""
                  placeholder="84e291f7-4b37-4767-97c2-b0fea0fc5936"
                />
                <div class="c-error c-error--balloon">
                  <div class="c-error__text"></div>
                </div>
              </div>
              <div class="c-select u-w162">
                <div class="c-select__selected">
                  等しい
                </div>
                <div class="c-select-options">
                  <div class="c-select-options__item" data-value="1">等しい</div>
                  <div class="c-select-options__item" data-value="2">等しくない</div>
                  <div class="c-select-options__item" data-value="3">含む</div>
                </div>
                <input type="hidden" name="uuid_access_page_manual_operator" value="" />
                <div class="c-error c-error--balloon">
                  <div class="c-error__text"></div>
                </div>
              </div>
            </div>
            <div class="p-message-edit-condition-group__item p-message-edit-condition-group__item--template">
              <div class="c-input u-w456">
                <input
                  class="c-input__item"
                  type="text"
                  name="uuid_access_page_manual"
                  value=""
                  placeholder="84e291f7-4b37-4767-97c2-b0fea0fc5936"
                />
                <div class="c-error c-error--balloon">
                  <div class="c-error__text"></div>
                </div>
              </div>
              <div class="c-select u-w162">
                <div class="c-select__selected">
                  等しい
                </div>
                <div class="c-select-options">
                  <div class="c-select-options__item" data-value="1">等しい</div>
                  <div class="c-select-options__item" data-value="2">等しくない</div>
                  <div class="c-select-options__item" data-value="3">含む</div>
                </div>
                <input type="hidden" name="uuid_access_page_manual_operator" value="" />
                <div class="c-error c-error--balloon">
                  <div class="c-error__text"></div>
                </div>
              </div>
            </div>
          </div>

          <button
            class="c-btn c-btn--blue-dashed u-w100p u-h40 u-fs14"
            type="button"
            name="add_custom_key_condition"
            value="add_custom_key_condition"
          >
            <div class="c-icon-circle c-icon-circle--blue u-wh20">
              <div class="c-icon-circle__item c-icon-circle__item--white u-wh12">
                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                  <use xlink:href="/assets/img/sprite.svg#plus" />
                </svg>
              </div>
            </div>
            <p class="c-btn__text">さらに条件を追加する</p>
          </button>

        </div>
      </div>
    </div>
    <div class="p-message-edit p-message-edit--segment">
      <div class="c-title">
        <div class="c-title__text u-fs24">デモグラフィック（属性）</div>
      </div>
      <div class="p-message-edit-list">
        <div class="p-message-edit-list__item">
          <div class="c-select-label c-select-label--gender">
            <div class="c-select-label__title">性別</div>
            <ul class="c-select-label-list">
              <li class="c-select-label-list__item">
                <label class="c-select-label__label">
                  <input type="checkbox" name="demogra_gender" value="1" />
                  <div class="c-select-label__item">すべて</div>
                </label>
              </li>
              <li class="c-select-label-list__item">
                <label class="c-select-label__label">
                  <input type="checkbox" name="demogra_gender" value="2" />
                  <div class="c-select-label__item">男性</div>
                </label>
              </li>
              <li class="c-select-label-list__item">
                <label class="c-select-label__label">
                  <input type="checkbox" name="demogra_gender" value="3" />
                  <div class="c-select-label__item">女性</div>
                </label>
              </li>
            </ul>
            <div class="c-error c-error--balloon">
              <div class="c-error__text"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="p-message-edit-list">
        <div class="p-message-edit-list__item">
          <div class="c-select-label c-select-label--age">
            <div class="c-select-label__title">年齢</div>
            <ul class="c-select-label-list">
              <li class="c-select-label-list__item">
                <label class="c-select-label__label">
                  <input type="checkbox" name="demogra_age" value="1" />
                  <div class="c-select-label__item">すべて</div>
                </label>
              </li>
              <li class="c-select-label-list__item">
                <label class="c-select-label__label">
                  <input type="checkbox" name="demogra_age" value="2" />
                  <div class="c-select-label__item">15歳-20歳</div>
                </label>
              </li>
              <li class="c-select-label-list__item">
                <label class="c-select-label__label">
                  <input type="checkbox" name="demogra_age" value="3" />
                  <div class="c-select-label__item">20歳-25歳</div>
                </label>
              </li>
              <li class="c-select-label-list__item">
                <label class="c-select-label__label">
                  <input type="checkbox" name="demogra_age" value="4" />
                  <div class="c-select-label__item">25歳-30歳</div>
                </label>
              </li>
              <li class="c-select-label-list__item">
                <label class="c-select-label__label">
                  <input type="checkbox" name="demogra_age" value="5" />
                  <div class="c-select-label__item">30歳-35歳</div>
                </label>
              </li>
              <li class="c-select-label-list__item">
                <label class="c-select-label__label">
                  <input type="checkbox" name="demogra_age" value="6" />
                  <div class="c-select-label__item">35歳-40歳</div>
                </label>
              </li>
              <li class="c-select-label-list__item">
                <label class="c-select-label__label">
                  <input type="checkbox" name="demogra_age" value="7" />
                  <div class="c-select-label__item">40歳-45歳</div>
                </label>
              </li>
              <li class="c-select-label-list__item">
                <label class="c-select-label__label">
                  <input type="checkbox" name="demogra_age" value="8" />
                  <div class="c-select-label__item">50歳以上</div>
                </label>
              </li>
            </ul>
            <div class="c-error c-error--balloon">
              <div class="c-error__text"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="p-message-edit-list">
        <div class="p-message-edit-list__item">
          <div class="c-select-label c-select-label--pref">
            <div class="c-select-label__title">地域</div>
            <ul class="c-select-label-list">
              <li class="c-select-label-list__item">
                <label class="c-select-label__label">
                  <input type="checkbox" name="demogra_pref" value="1" />
                  <div class="c-select-label__item">すべて</div>
                </label>
              </li>
              <li class="c-select-label-list__item">
                <label class="c-select-label__label">
                  <input type="checkbox" name="demogra_pref" value="2" />
                  <div class="c-select-label__item">北海道</div>
                </label>
              </li>
              <li class="c-select-label-list__item">
                <label class="c-select-label__label">
                  <input type="checkbox" name="demogra_pref" value="3" />
                  <div class="c-select-label__item">東北</div>
                </label>
              </li>
              <li class="c-select-label-list__item">
                <label class="c-select-label__label">
                  <input type="checkbox" name="demogra_pref" value="4" />
                  <div class="c-select-label__item">関東</div>
                </label>
              </li>
              <li class="c-select-label-list__item">
                <label class="c-select-label__label">
                  <input type="checkbox" name="demogra_pref" value="5" />
                  <div class="c-select-label__item">中部</div>
                </label>
              </li>
              <li class="c-select-label-list__item">
                <label class="c-select-label__label">
                  <input type="checkbox" name="demogra_pref" value="6" />
                  <div class="c-select-label__item">近畿</div>
                </label>
              </li>
              <li class="c-select-label-list__item">
                <label class="c-select-label__label">
                  <input type="checkbox" name="demogra_pref" value="7" />
                  <div class="c-select-label__item">中国</div>
                </label>
              </li>
              <li class="c-select-label-list__item">
                <label class="c-select-label__label">
                  <input type="checkbox" name="demogra_pref" value="8" />
                  <div class="c-select-label__item">四国</div>
                </label>
              </li>
              <li class="c-select-label-list__item">
                <label class="c-select-label__label">
                  <input type="checkbox" name="demogra_pref" value="9" />
                  <div class="c-select-label__item">九州・沖縄</div>
                </label>
              </li>
            </ul>
            <div class="c-error c-error--balloon">
              <div class="c-error__text"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="c-title c-title--wrap c-title--audience ">
        <div class="c-title__text u-fs24">オーディエンス（興味・関心）</div>
        <div class="c-text u-fs--s">説明の文章が入ります説明の文章が入ります説明の文章が入ります説明の文章が入ります説明の文章が入ります説明の文章が入ります説明の文章が入ります説明の文章が入ります説明の文章が入ります説明の文章が入ります説明の文章が入ります説明の文章が入ります</div>
      </div>
      <div class="p-message-edit-list">
        <div class="p-message-edit-list__item">
          <div class="c-select">
            <div class="c-select__title">
              興味トップ
            </div>
            <div class="c-select__selected is-empty">
              ユーザーが興味・関心のあるセグメントを選択してください
            </div>
            <div class="c-select-options">
              <div class="c-select-options__item" data-value="1">興味・関心セグメント1</div>
              <div class="c-select-options__item" data-value="2">興味・関心セグメント2</div>
              <div class="c-select-options__item" data-value="3">興味・関心セグメント3</div>
              <div class="c-select-options__item" data-value="4">興味・関心セグメント4</div>
              <div class="c-select-options__item" data-value="5">興味・関心セグメント5</div>
              <div class="c-select-options__item" data-value="6">興味・関心セグメント6</div>
              <div class="c-select-options__item" data-value="7">興味・関心セグメント7</div>
              <div class="c-select-options__item" data-value="7">興味・関心セグメント8</div>
              <div class="c-select-options__item" data-value="8">興味・関心セグメント9</div>
              <div class="c-select-options__item" data-value="10">興味・関心セグメント10</div>
            </div>
            <div class="c-error c-error--balloon">
              <div class="c-error__text"></div>
            </div>
            <input type="hidden" name="interest_category" value="" />
          </div>
        </div>
        <div class="p-message-edit-list__item">
          <div class="c-select">
            <div class="c-select__title">
              キーワードトップ
            </div>
            <div class="c-select__selected is-empty">
              キーワードを選択してください
            </div>
            <div class="c-select-options">
              <div class="c-select-options__item" data-value="1">キーワード1</div>
              <div class="c-select-options__item" data-value="2">キーワード2</div>
              <div class="c-select-options__item" data-value="3">キーワード3</div>
              <div class="c-select-options__item" data-value="4">キーワード4</div>
              <div class="c-select-options__item" data-value="5">キーワード5</div>
              <div class="c-select-options__item" data-value="6">キーワード6</div>
              <div class="c-select-options__item" data-value="7">キーワード7</div>
              <div class="c-select-options__item" data-value="7">キーワード8</div>
              <div class="c-select-options__item" data-value="8">キーワード9</div>
              <div class="c-select-options__item" data-value="10">キーワード10</div>
            </div>
            <div class="c-error c-error--balloon">
              <div class="c-error__text"></div>
            </div>
            <input type="hidden" name="interest_keyword" value="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>
